import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectToServiceComponent } from './connect-to-service.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ConnectToServiceComponent],
  imports: [CommonModule, MatButtonModule, TranslateModule],
  exports: [ConnectToServiceComponent],
})
export class ConnectToServiceModule {}
